import { CookieNames, setCookie } from "../helpers";
import { usePassportStore } from "../stores";
import { useHistory } from "react-router-dom";

export const usePassportImprovements = () => {
  const store = usePassportStore();
  const history = useHistory();

  const enableImprovementsAndRedirect = async () => {
    await store.addFeatureTypes(["MIDTRANS_PASSPORT_ACTIVATION"]);
    setCookie(CookieNames.PassportStep, "/owner-info");
    history.push("/owner-info");
  };

  return {
    enableImprovementsAndRedirect,
    isImprovementEnabled: store.isImprovementEnabled,
  };
};
